var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { StyledInputLabel } from './InputLabel.styled';
const defaultProps = {
  isFloating: false,
  isShrink: false,
  skin: 'light'
};

const InputLabel = _a => {
  var {
    children,
    isFloating = defaultProps.isFloating,
    isShrink = defaultProps.isShrink,
    isDisabled,
    skin = defaultProps.skin,
    size,
    isRightIcon,
    htmlFor
  } = _a,
      other = __rest(_a, ["children", "isFloating", "isShrink", "isDisabled", "skin", "size", "isRightIcon", "htmlFor"]);

  return React.createElement(StyledInputLabel, Object.assign({
    isFloating: isFloating,
    isShrink: isShrink,
    skin: skin,
    size: size,
    isRightIcon: isRightIcon,
    isDisabled: isDisabled,
    htmlFor: htmlFor
  }, other), children);
};

export default InputLabel;